import "./RentalAnalysis.module.css";
import Header from "@/reusable_sections/Header";
import BusinessesOverviewHero from "./sections/BusinessesOverviewHero";
import Contact from "./sections/Contact";
import ImpactSocial from "./sections/ImpactSocial";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function RentalAnalysisPage() {
  return <div>
      <Header />
      <BusinessesOverviewHero />
      <Contact />
      <ImpactSocial />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}